module.exports = __webpack_public_path__ + "img/calendar-10_fill.606c8579.svg";